// const getDateFromUnix = (unixTimesamp) => {
//   const date = new Date(Math.floor(unixTimesamp * 1000));

import { getCurrentLanguage } from "@helpers/idiomas/validation/getCurrentLanguage";

//   const dateFormatter = new Intl.DateTimeFormat("es-ES", {
//     dateStyle: "full",
//   });

//   return dateFormatter.format(date);
// };


const getDateFromUnix = (unixTimestamp) => {
  const date = new Date(unixTimestamp * 1000);

  const language = getCurrentLanguage();

  const currLanguage = language === 'es' ? "es-Es" : "en-En";

  // Obtén la fecha formateada en el huso horario local
  const fechaFormateada = date.toLocaleString(currLanguage, {
    dateStyle: "full",
    timeZone: "UTC", // Ajusta el huso horario según tu necesidad
  });

  return fechaFormateada;
};

export default getDateFromUnix;
